import CoreuiController from "../lib/coreui-controller"
import Popover from "../coreui/popover"

export default class CoreuiPopoverController extends CoreuiController {
  static Component = Popover
}
